import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CapitalBalanceSummaryView from './components/CapitalBalanceSummaryView';
import { FISCAL_CAPITAL_BALANCE_CONFIG } from './config';

const FiscalCapitalBalanceSummaryView = () => {
  return (
    <>
      <RolePrivateRoute
        component={() => (
          <CapitalBalanceSummaryView
            config={FISCAL_CAPITAL_BALANCE_CONFIG}
          />
        )}
      />
    </>
  );
};


export default FiscalCapitalBalanceSummaryView;

